import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { FormValidation, HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { HabitabilidadDetalleDTO, HabitabilidadDTO, InputReporte, OutputReporteHabitabilidad, OutputVistaInformacionGeneral, SeguridadSalida, TipoHabitabilidad } from 'src/app/modelo';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-habitabilidad',
    templateUrl: './habitabilidad.component.html',
    //styleUrls: ['./ecotecnologias-atributos.component.css']
})
export class HabitabilidadComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public habitabilidad: OutputReporteHabitabilidad;
    public entity: HabitabilidadDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public btn_Disabled: boolean;


    //Validaciones

    public entregables_MensajeError: FormValidation = new FormValidation(null);

   /**
    * 
    * @param servicioIndicadorCarga
    * @param servicioAlertas
    * @param service
    * @param _router
    * @param spinner
    */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('HabitabilidadComponent -->> ', new Date());

    }

    /**
     * 
     */
    public async ngOnInit() {
        this.entity = <HabitabilidadDTO>{};
        this.habitabilidad = <OutputReporteHabitabilidad>{ listaHabitabilidad: [] };
    }

    /**
    * 
    */
    public async init() {
        await this.loading(null);
    }
   

   /**
    * 
    * @param idVivienda
    */
    public async loading(idVivienda:number | null) {

        this.btn_Disabled = true;

        this.entity = <HabitabilidadDTO>{};

        this.habitabilidad = <OutputReporteHabitabilidad>{ listaHabitabilidad: [] };

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteHabitabilidad> = await this.service.ObtenerReporteHabitabilidad(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.habitabilidad = resultado.model;

            if (this.habitabilidad.listaHabitabilidad != null && this.habitabilidad.listaHabitabilidad.length > 0) {

                for (let row of this.habitabilidad.listaHabitabilidad) {

                    for (let habitabilidadDetalle of row.listHabitabilidadDetalle) {
                        habitabilidadDetalle.actualizado = false;
                    }

                    for (let habitabilidadDetalleOpcionales of row.listHabitabilidadDetalleOpcionales) {
                        habitabilidadDetalleOpcionales.actualizado = false;
                    }
                }

                if (idVivienda == null) {

                    this.entity = this.habitabilidad.listaHabitabilidad[0];

                    this.entity.claveEstatus = this.habitabilidad.listaHabitabilidad[0].claveEstatus;

                } else {

                    let filter = this.habitabilidad.listaHabitabilidad.filter(row => row.indentificadorVivienda == idVivienda);

                    if (filter != null && filter.length > 0 ) {
                        this.entity = filter[0];
                    }
                    
                }

                this.ExisteCumplimiento();

                //this.btn_Disabled = false;

                //this.entity.claveEstatus = 0;

                this.onRowSelect(this.entity);

                //Copiar valor propiedad 

                for (let habitabilidad of this.habitabilidad.listaHabitabilidad) {

                    for (let habitabilidadDetalle of habitabilidad.listHabitabilidadDetalle) {

                        habitabilidadDetalle.condicion_TMP = habitabilidadDetalle.condicion;

                    }

                    for (let habitabilidadDetalle of habitabilidad.listHabitabilidadDetalleOpcionales) {

                        habitabilidadDetalle.condicion_TMP = habitabilidadDetalle.condicion;

                    }

                }

            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
     * 
     * @param entity
     */
    public onRowSelect(entity: HabitabilidadDTO): void {

        let object: HabitabilidadDTO = this.habitabilidad.listaHabitabilidad.filter(row => row.indentificadorVivienda == entity.indentificadorVivienda)[0];

        this.entity = object;

        this.entity.claveEstatus = entity.claveEstatus;

        this.entity.entregables = false;

        for (let row of this.entity.listHabitabilidadDetalleOpcionales) {

            if (row.condicion == 1) {
                this.entity.entregables = true;
                break;
            }

        }

        this.entity.entregables_TMPS = this.entity.entregables;

        this.ExisteCumplimiento();
    }

   /**
    * 
    */
    private ExisteCumplimiento(): boolean {

        this.btn_Disabled = true;

        if (this.entity != null && this.entity.listHabitabilidadDetalle) {

            let contador: number = 0;

            for (let row of this.entity.listHabitabilidadDetalle) {

                if (row.rutaDocumento == null) {
                    contador++;
                }

            }

            if (contador == 1 ) {
                this.btn_Disabled = false;
            }

        }

        return this.btn_Disabled;

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
     * 
     */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
     * 
     */
    public validarFormumlario(): boolean {

        var error = false;

        this.entregables_MensajeError = this.actualizarErrores('entregables');

        if (this.entregables_MensajeError.error == true) {
            error = true;
        }

        return error;
    }

    /**
     * 
     * @param tipo
     */
    public actualizarErrores(tipo: string): FormValidation {

        let error: FormValidation = null;

        switch (tipo) {

            case 'entregables':

                this.entregables_MensajeError = new FormValidation(null);

                if (this.entity.entregables == true) {

                    let cont: number = this.entity.listHabitabilidadDetalleOpcionales.filter(row => row.condicion == 1).length;

                    if (cont == 0) {
                        this.entregables_MensajeError = new FormValidation(null).requered('Debe tener al menos un elemento seleccionado de la lista.');
                    }

                }

                error = this.entregables_MensajeError;

                break;

        }

        return error;

    }

    /**
    * 
    */
    public async Guardar() {

        if (!this.validarFormumlario()) {

            let reporteHabitabilidad: OutputReporteHabitabilidad = <OutputReporteHabitabilidad>{
                ordenVerificacion: this.habitabilidad.ordenVerificacion,
                totalVivienda: this.habitabilidad.totalVivienda,
                nombreFrente: this.habitabilidad.nombreFrente,
                estatus: this.habitabilidad.estatus,
                claveEstatus: this.habitabilidad.claveEstatus,
                listTipoHabitabilidad: null
            };

            let listaHabitabilidad: HabitabilidadDTO[] = [];

            for (let listHabitabilidad of this.habitabilidad.listaHabitabilidad) {

                let contador: number = 0;

                let listHabitabilidadDetalle = listHabitabilidad.listHabitabilidadDetalle.filter(row => row.actualizado == true);

                let listHabitabilidadDetalleOpcionales = listHabitabilidad.listHabitabilidadDetalleOpcionales.filter(row => row.actualizado == true);

                if (listHabitabilidadDetalle.length > 0 || listHabitabilidadDetalleOpcionales.length > 0) {
                    listaHabitabilidad.push(listHabitabilidad);
                }
            }

            reporteHabitabilidad.listaHabitabilidad = listaHabitabilidad;

            //let json = JSON.stringify(this.habitabilidad); 

            let json = JSON.stringify(reporteHabitabilidad);

            let habitabilidad: OutputReporteHabitabilidad = JSON.parse(json);

            habitabilidad.listTipoHabitabilidad = null;

            Util.showLoadingMessage(this.spinner, `Guardando información de reporte habitabilidad ...`);

            let resultado: JsonResponse<boolean> = await this.service.GuardarReporteHabitabilidad(habitabilidad).toPromise();

            Util.hideLoadingMessage();

            if (resultado != null && resultado.code == 200) {

                let respuesta: boolean = resultado.model;

                if (respuesta == true) {

                    var strCallback = (): void => {
                        this.Regresar();
                    }

                    let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);

                }

            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
                console.error(resultado.message)
            }

        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Favor de validar los datos solicitados ...', 'warning');
        }

    }

    /**
     * 
     * @param property
     * @param value
     */
    public onChangeCumplimiento(entity: HabitabilidadDetalleDTO, value: number) {
        entity.condicion = value;
        entity.actualizado = true;
    }

    /**
     * 
     * @param entity
     */
    public onLink(entity: HabitabilidadDetalleDTO) {

        this.habitabilidad.modal = true;

        switch (entity.idCatalogoDocumento) {
            case 1:
                //Energía eléctrica
                {
                    this.habitabilidad.modalTitulo = 'Energía eléctrica';
                    this.habitabilidad.url = entity.rutaDocumento;
                }
                break;
            case 2:
                //Agua
                {
                    this.habitabilidad.modalTitulo = 'Agua';
                    this.habitabilidad.url = entity.rutaDocumento;
                }
                break;
            case 3:
                //Drenaje y alcantarillado
                {
                    this.habitabilidad.modalTitulo = 'Drenaje y alcantarillad';
                    this.habitabilidad.url = entity.rutaDocumento;
                }

                break;
            case 4:
                //Condiciones físicas

                {
                    this.habitabilidad.modalTitulo = 'Condiciones físicas';
                    this.habitabilidad.url = entity.rutaDocumento;
                }

                break;

        }

        this.habitabilidad.imgVisible = false;

        if (this.habitabilidad.url != null) {

            this.habitabilidad.url = this.habitabilidad.url.toLowerCase();

            if (this.habitabilidad.url.includes('.jpg') == true ||
                this.habitabilidad.url.includes('.png') == true ||
                this.habitabilidad.url.includes('.gif') == true ||
                this.habitabilidad.url.includes('.bmp') == true) {
                this.habitabilidad.imgVisible = true;
            }

        } else {
            this.habitabilidad.modal = false;
        }

        console.log('this.habitabilidad.url -->> ', this.habitabilidad.url)
    }

    /**
     * 
     */
    public closeModal(): void {
        this.habitabilidad.modal = false;
    }

    /**
     * 
     */
    public onChangeEntregables(): void {

        if (this.entity.entregables == false) {

            for (let row of this.entity.listHabitabilidadDetalleOpcionales) {
                row.condicion = 0;
            }

            this.actualizarErrores('entregables');
        }

        this.getDisabledOpcionales();

    }

    /**
     * 
     * @param idTipoHabitabilidad
     */
    public getTipoHabitabilidad(idTipoHabitabilidad: number): number {

        let total: number = 0;

        if (this.habitabilidad != null && this.habitabilidad.listTipoHabitabilidad != null) {

            let lista: TipoHabitabilidad[] = this.habitabilidad.listTipoHabitabilidad.filter(row => row.tipoHabitabilidad == idTipoHabitabilidad);

            if (lista != null && lista.length > 0) {
                total = lista[0].total;
            }

        }

        return total;
    }

    /**
     * 
     * @param entity
     * @param checked
     */
    public onChangeEntregablesOpcionales(entity: HabitabilidadDetalleDTO, checked: any): void {

        if (checked == true) {
            entity.condicion = 1;
            entity.actualizado = true;
        } else {
            entity.condicion = 0;
            entity.actualizado = false;
        }

        this.actualizarErrores('entregables');

    }

    /**
     * 
     * @param entity
     */
    public getDisabled(entity: HabitabilidadDetalleDTO): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (entity != null && (entity.condicion_TMP == 0 || entity.condicion_TMP == 1) ) {
            resultado = true;
        }

        if (this.ExisteCumplimiento() == true) {
            resultado = true;
        }

        return resultado;
    }


    public getDisabledEntregables(): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (this.entity.listHabitabilidadDetalleOpcionales != null) {

            for (let row of this.entity.listHabitabilidadDetalleOpcionales) {

                if (row.condicion_TMP == 1) {
                    resultado = true;
                    break;
                }

            }

        }

        if (this.ExisteCumplimiento() == true) {
            resultado = true;
        }

        return resultado;
    }

    /**
     * 
     */
    public getDisabledOpcionales(): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (this.entity.listHabitabilidadDetalleOpcionales != null) {

            for (let row of this.entity.listHabitabilidadDetalleOpcionales) {

                if (row.condicion_TMP == 1) {
                    resultado = true;
                    break;
                }

            }

            if (this.entity.entregables == false) {
                resultado = true;
            }

        }

        return resultado;
    }

}


